/**
 * Benchmark filter defaults and dropdown options (issue #102).
 * The therapeutic-area and study-type options are reused from studyFieldOptions
 * so the benchmark filters stay in lockstep with the study parameter fields.
 */

import { IBenchmarkFilters } from '../types/studyBudget'
import { DropdownOption } from './studyFieldOptions'

/** The no-filter state: benchmark against every accepted/declined budget. */
export const DEFAULT_BENCHMARK_FILTERS: IBenchmarkFilters = {
  therapeutic_area: [],
  study_type: [],
  sponsor: [],
  studies: [],
  creation_date: 'all',
}

/** Creation-date window options (values match backend BenchmarkFilters.creation_date). */
export const creationDateOptions: DropdownOption[] = [
  { key: 'all', value: 'all', text: 'All time' },
  { key: 'this_year', value: 'this_year', text: 'This year' },
  { key: 'last_6_months', value: 'last_6_months', text: 'Last 6 months' },
  { key: 'last_12_months', value: 'last_12_months', text: 'Last 12 months' },
  { key: 'last_3_years', value: 'last_3_years', text: 'Last 3 years' },
]

/**
 * True when any filter deviates from the defaults. Drives the purple "active"
 * state of the benchmark icons and whether the filter chips are shown.
 * @example isBenchmarkFilterActive(DEFAULT_BENCHMARK_FILTERS) // false
 */
export const isBenchmarkFilterActive = (f: IBenchmarkFilters): boolean =>
  f.therapeutic_area.length > 0 ||
  f.study_type.length > 0 ||
  f.sponsor.length > 0 ||
  f.studies.length > 0 ||
  f.creation_date !== 'all'
